import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { iniciarSesionPortal, inciarSesionMoodle, verificarEstudianteBloqueado } from '../api/AuthService';
import { mostrarToastError } from 'src/utils/Toast';
import { setDate } from 'date-fns';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    // VERIFICAR SI HAY USUARIO EN EL LOCALSTORAGE AL CARGAR LA PÁGINA
    const storedUsuario = localStorage.getItem('usuario');
    const storedToken = localStorage.getItem('token');
    if (storedUsuario && storedToken) {
      setUsuario(JSON.parse(storedUsuario));
      setToken(storedToken);
    } else {
      setUsuario({});
      setToken("")
    }
  }, []);

  const iniciarSesion = async (correo, contrasenha) => {
    try {

      const moodleRes = await inciarSesionMoodle(correo, contrasenha);
      if (!moodleRes.access_token) {
        console.log('No se pudo obtener el token de acceso.');
      }

      const token = moodleRes.access_token;
      const portalRes = await iniciarSesionPortal(token);
      const evaluacionRes = await verificarEstudianteBloqueado(token, portalRes.content.estudiante.cod_directorio_est);

      if (portalRes.success) {
        if (evaluacionRes.success) { //? True is blocked
          mostrarToastError('Error', evaluacionRes.description);
        }else{
          const usuario = portalRes.content.estudiante;
          if (usuario) {
            let fecha_actual = new Date();
            let dia = (fecha_actual.getDate() + 1).toString().padStart(2, '0');
            let mes = (fecha_actual.getMonth() + 1).toString().padStart(2, '0');
            let hora = fecha_actual.getHours().toString().padStart(2, '0');
            let minutos = fecha_actual.getMinutes().toString().padStart(2, '0');
            let segundos = fecha_actual.getSeconds().toString().padStart(2, '0');
            let fecha_actual_token  = fecha_actual.getFullYear() + '-' + mes + '-' + dia;
            let hora_actual = hora + ':' + minutos + ':' + segundos;
            const fecha_completa_token = fecha_actual_token + ' ' + hora_actual;
            const fecha_codificada = btoa(fecha_completa_token);
            const pass_est = btoa(contrasenha);

            localStorage.setItem('usuario', JSON.stringify(usuario));
            localStorage.setItem('token', token);
            localStorage.setItem('expired_date' , fecha_codificada );
            localStorage.setItem('pass_est' , pass_est );
            setUsuario(usuario);
            navigate('/inicio');
          }
        }

      } else {
        mostrarToastError('Error', portalRes.description);
      }
    } catch (error) {
      mostrarToastError('Error', 'Usuario o contraseña incorrectos');
    }
  };

  const cerrarSesion = () => {
    // LÓGICA DE CERRAR SESIÓN
    localStorage.removeItem('usuario');
    localStorage.removeItem('token');
    localStorage.removeItem('expired_date');
    localStorage.removeItem('pass_est');
    setUsuario(null);
    setToken(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ iniciarSesion, cerrarSesion, usuario, setUsuario, token }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
